// v2/hooks/useToast.js
import { useState, useCallback, useRef, useEffect } from 'react';

const MAX_VISIBLE = 3;

export default function useToast(duration = 2600) {
  const [items, setItems] = useState([]);
  const timers = useRef(new Map());

  const clearTimer = useCallback((id) => {
    const t = timers.current.get(id);
    if (t) { clearTimeout(t); timers.current.delete(id); }
  }, []);

  const dismiss = useCallback((id) => {
    clearTimer(id);
    setItems((cur) => cur.filter((i) => i.id !== id));
  }, [clearTimer]);

  const push = useCallback((message, type = 'success') => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    setItems((cur) => {
      const next = [...cur, { id, message, type, duration }];
      // en eskileri dusur, ekranda en fazla MAX_VISIBLE bildirim kalsin
      if (next.length > MAX_VISIBLE) {
        next.slice(0, next.length - MAX_VISIBLE).forEach((i) => clearTimer(i.id));
        return next.slice(-MAX_VISIBLE);
      }
      return next;
    });
    const t = setTimeout(() => dismiss(id), duration);
    timers.current.set(id, t);
    return id;
  }, [duration, dismiss, clearTimer]);

  useEffect(() => {
    const map = timers.current;
    return () => { map.forEach(clearTimeout); map.clear(); };
  }, []);

  return { items, push, dismiss };
}
